import { memo } from "react";
import { Navigate, useLocation } from "react-router-dom";

interface SettingsTabRedirectProps {
  from: string;
  to: string;
  section: string;
  /** Focus this group when the original URL has no group target. */
  defaultGroup?: string;
  sectionByLegacyTab?: Record<string, string>;
}

export const SettingsTabRedirect = memo(function SettingsTabRedirect({
  from,
  defaultGroup,
  section,
  sectionByLegacyTab,
  to,
}: SettingsTabRedirectProps) {
  const { hash, pathname, search } = useLocation();
  if (!pathname.includes(from)) {
    return null;
  }
  const params = new URLSearchParams(search);
  if (defaultGroup && !params.has("group")) {
    params.set("group", defaultGroup);
  }
  const legacyTab = params.get("tab");
  params.set(
    "section",
    (legacyTab && sectionByLegacyTab?.[legacyTab]) || section,
  );
  if (sectionByLegacyTab) {
    params.delete("tab");
  }
  return (
    <Navigate
      replace
      to={`${pathname.replace(from, to)}?${params.toString()}${hash}`}
    />
  );
});
